module finadai.app.upload {
  export var NAME = 'finadai.app.upload';
  function ConfigRoutes($stateProvider: ng.ui.IStateProvider){
    $stateProvider.state('app.upload', {
      url: '/upload',
      templateUrl: 'app/upload/upload.tpl.html',
      controller: 'UploadController'
    });
  }
  function UploadController($scope, $element: ng.IRootElementService, FileUploader, proxifier, $localStorage: IFinadaiStorage, notify){
    $scope.fileData = { operation: 'create', type: 'full' };
    $scope.uploader = new FileUploader({
      url: [proxifier(), 'finadai', 'customers', 'file'].join('/'),
      formData: {'key': 'value'}
    });
    $scope.selectFile = () => {
      jQuery('input#fileChoose').trigger('click');
    }
    $scope.uploader.onBeforeUploadItem = function(item){
      item.formData = jQuery.makeArray($scope.fileData);
      item.headers = {Authorization: $localStorage.apiToken};
    }
    $scope.uploader.onSuccessItem = (item, response, status, headers) => {
      $scope.fileData = {};
      $scope.uploadForm.$setPristine();
      $scope.uploadForm.$setUntouched();
      notify('El archivo ha sido agregado y será procesado en un momento.');
      $scope.uploader.clearQueue();
    }
    $scope.submit = () => {
      if($scope.uploader.queue.length > 0){
        $scope.uploader.uploadAll();
      }
    }
  }
  export function run(){
    var upload = angular.module(NAME, []);
    upload.config(ConfigRoutes);
    upload.controller('UploadController', UploadController);
  }
}
finadai.app.upload.run();